// extracted by mini-css-extract-plugin
export var iconSkeleton = "CardMethodIcon-module--iconSkeleton--66a04";